import React from "react";
import "../FooterLinks.css";
import { FaInstagram } from "react-icons/fa";

function FooterLinks() {
  return (
    <div className="footer-links">
      <a href="/contact">Contact Us</a>
      <a href="/about">About Us</a>
      <a href="/faq">FAQ</a>
      <a href="/privacy">Privacy Policy</a>
      <a href="/terms">Terms of Use</a>
      <a href="https://www.instagram.com/pharmpreppro/?hl=en" target="_blank" rel="noopener noreferrer">
        <FaInstagram className="footer-icon" />
      </a>
    </div>
  );
}

export default FooterLinks;
